import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-52">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl flex items-center justify-between" data-id="element-53">
        <div className="flex items-center" data-id="element-54">
          <span className="font-serif text-xl md:text-2xl font-bold text-[#4A3B32]" data-id="element-55">
            Adiós<span className="text-[#14B8A6]" data-id="element-56">Panza</span>
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-57">
          <a href="#how-it-works" className="text-[#4A3B32] hover:text-[#14B8A6] font-medium transition-colors" data-id="element-58">
            Cómo Funciona
          </a>
          <a href="#testimonials" className="text-[#4A3B32] hover:text-[#14B8A6] font-medium transition-colors" data-id="element-59">
            Testimonios
          </a>
          <a href="#faq" className="text-[#4A3B32] hover:text-[#14B8A6] font-medium transition-colors" data-id="element-60">
            Preguntas
          </a>
          <Button onClick={scrollToOffer} size="sm" variant="primary" data-id="element-61">
            Obtener Guía
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-[#4A3B32]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-62">
          {isMobileMenuOpen ? <X size={24} data-id="element-63" /> : <Menu size={24} data-id="element-64" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-65">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-66">
            <div className="flex flex-col p-4 space-y-4" data-id="element-67">
              <a href="#how-it-works" className="text-[#4A3B32] font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-68">
                Cómo Funciona
              </a>
              <a href="#testimonials" className="text-[#4A3B32] font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-69">
                Testimonios
              </a>
              <a href="#faq" className="text-[#4A3B32] font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-70">
                Preguntas
              </a>
              <Button onClick={scrollToOffer} fullWidth variant="primary" data-id="element-71">
                Obtener Guía Ahora
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}